import gsap from 'gsap';

class Location{    
	constructor() {
		this.data = {
			
		};
		this.init();
        this.initMap = this.initMap.bind(this);
	}
  
	init() {		 
        // Initialize and add the map   
        setTimeout(() => {            
            window.initMap = this.initMap();
        }, 500);
                                
        
	}	

    initMap() {        
        // The map, centered at Uluru
        const coords = document.getElementById("map").dataset.coords.split(',');                
        const finalCoords = {lat: parseFloat(coords[0]), lng:parseFloat(coords[1])}             
        const image = window.location.origin+'/wp-content/themes/goodfill/assets/public/images/marker.png';
        
        const icon = {
            url: image,
            scaledSize: new google.maps.Size(35,50)
        }
        const map = new google.maps.Map(document.getElementById("map"), {
            zoom: 12,
            center: finalCoords,
            // styles: [
            //     {
            //         "featureType": "administrative",
            //         "elementType": "all",
            //         "stylers": [
            //             {
            //                 "saturation": "-100"
            //             }
            //         ]
            //     },
            //     {
            //         "featureType": "administrative.province",
            //         "elementType": "all",
            //         "stylers": [
            //             {
            //                 "visibility": "off"
            //             }
            //         ]
            //     },
            //     {
            //         "featureType": "landscape",
            //         "elementType": "all",
            //         "stylers": [
            //             {
            //                 "saturation": -100
            //             },
            //             {
            //                 "lightness": 65
            //             },
            //             {
            //                 "visibility": "on"
            //             }
            //         ]
            //     },
            //     {
            //         "featureType": "poi",
            //         "elementType": "all",
            //         "stylers": [
            //             {
            //                 "saturation": -100
            //             },
            //             {
            //                 "lightness": "50"
            //             },
            //             {
            //                 "visibility": "simplified"
            //             }
            //         ]
            //     },
            //     {
            //         "featureType": "road",
            //         "elementType": "all",
            //         "stylers": [
            //             {
            //                 "saturation": "-100"
            //             }
            //         ]
            //     },
            //     {
            //         "featureType": "road.highway",
            //         "elementType": "all",
            //         "stylers": [
            //             {
            //                 "visibility": "simplified"
            //             }
            //         ]
            //     },
            //     {
            //         "featureType": "road.arterial",
            //         "elementType": "all",
            //         "stylers": [
            //             {
            //                 "lightness": "30"
            //             }
            //         ]
            //     },
            //     {
            //         "featureType": "road.local",
            //         "elementType": "all",
            //         "stylers": [
            //             {
            //                 "lightness": "40"
            //             }
            //         ]
            //     },
            //     {
            //         "featureType": "transit",
            //         "elementType": "all",
            //         "stylers": [
            //             {
            //                 "saturation": -100
            //             },
            //             {
            //                 "visibility": "simplified"
            //             }
            //         ]
            //     },
            //     {
            //         "featureType": "water",
            //         "elementType": "geometry",
            //         "stylers": [
            //             {
            //                 "hue": "#ffff00"
            //             },
            //             {
            //                 "lightness": -25
            //             },
            //             {
            //                 "saturation": -97
            //             }
            //         ]
            //     },
            //     {
            //         "featureType": "water",
            //         "elementType": "labels",
            //         "stylers": [
            //             {
            //                 "lightness": -25
            //             },
            //             {
            //                 "saturation": -100
            //             }
            //         ]
            //     }
            // ],
            styles: [
                {
                    "featureType": "all",
                    "elementType": "labels.text",
                    "stylers": [
                        {
                            "color": "#878787"
                        }
                    ]
                },
                {
                    "featureType": "all",
                    "elementType": "labels.text.stroke",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "landscape",
                    "elementType": "all",
                    "stylers": [
                        {
                            "color": "#F9F5ED"
                        }
                    ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "all",
                    "stylers": [
                        {
                            "color": "#F5F5F5"
                        }
                    ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "geometry.stroke",
                    "stylers": [
                        {
                            "color": "#C9C9C9"
                        }
                    ]
                },
                {
                    "featureType": "water",
                    "elementType": "all",
                    "stylers": [
                        {
                            "color": "#AEE0F4"
                        }
                    ]
                }
            ],
            disableDefaultUI: true,
        });
        // The marker, positioned at Uluru
        const marker = new google.maps.Marker({
            position: finalCoords,
            map: map,
            icon: icon
        });
    }    
}


export default Location